
export const locationAnalyticId = 'location';
export const locationChartId = 'locationChart';
export const locationTableId = 'locationTable';

export const trafficChannelsId = 'trafficChannels';
export const trafficChannelsChartId = 'trafficChannelsChart';
export const trafficChannelsTableId = 'trafficChannelsTable';
export const keywordReportTableId = 'keywordReportTable';
const pagePathId = 'pagePath';
const deviceCategoryId = 'deviceCategory';
export const DEFAULT_UPDATE_CONFIG_FIELDS = [
  {
    tabId: locationAnalyticId,
  },
  {
    tabId: trafficChannelsId,
    // ignoreUpdateChildIds: [keywordReportTableId], // uncomment this line to avoid update keyword table
  },
]

export const excludedTabForAdobeAdv =  [
  {
    tabId: deviceCategoryId,
    hiddenTab: true
  },
  {
    tabId: pagePathId,
    hiddenTab: true
  },
  {
    tabId: trafficChannelsId,
    hiddenChildList: [keywordReportTableId], // hidden children list
    ignoreUpdateChildIds: [trafficChannelsChartId, trafficChannelsTableId],
  },
]

export const snapshotIdOfSimpleReport = ['onAirLiftSnapshot', 'visitsSnapshot', 'userSessionSnapshot', 'totalAdsSnapshot', 'liftSnapshot', 'dualLiftSnapshot']